// TODO: substituir quando endpoint for criado no backend
// Backend não retorna XP/nível.
// Calculado localmente com base em sessions_count.

export interface PlayerLevel {
  level: number;
  xpCurrent: number;
  xpRequired: number;
  label: string;
}

export function computeLevel(sessionsCount: number): PlayerLevel {
  const xp = sessionsCount * 100;
  if (xp < 500) {
    return { level: 1, xpCurrent: xp, xpRequired: 500, label: 'Iniciante' };
  }
  if (xp < 1500) {
    return {
      level: 2,
      xpCurrent: xp - 500,
      xpRequired: 1000,
      label: 'Intermediário',
    };
  }
  return {
    level: 3,
    xpCurrent: Math.min(xp - 1500, 2000),
    xpRequired: 2000,
    label: 'Avançado',
  };
}
